import { HELLO_BAR_ACTIONS } from './actionTypes';

export function setHelloBarCount(data) {
  return {
    type: HELLO_BAR_ACTIONS.SET_COUNT,
    payload: data,
  };
}

export function forceRefreshNotificationCount(data) {
  return {
    type: HELLO_BAR_ACTIONS.FORCE_REFRESH,
    payload: data,
  };
}
